export default class Menu {
  menuBtn: HTMLElement | null;
  subMenus: NodeListOf<HTMLLIElement>;
  mainNav: HTMLElement | null;
  close: HTMLElement | null;

  constructor() {
    this.menuBtn = document.querySelector<HTMLElement>('.menu-button--primary');
    this.mainNav = document.querySelector<HTMLElement>('.main-navigation');
    this.close = document.querySelector<HTMLElement>('.menu-close');

    if (this.menuBtn) {
      this.menuBtn.addEventListener('click', this.toggleMenu.bind(this));
    }

    if (this.close) {
      this.close.addEventListener('click', this.toggleMenu.bind(this));
    }

    this.subMenus = document.querySelectorAll<HTMLLIElement>('.menu-item-has-children');
    this.subMenus.forEach((elem) => {
      elem.addEventListener('click', this.handleSubMenuClick.bind(this));
    });
  }





  toggleMenu(): void {
    this.menuBtn?.classList.toggle('is-open');
    this.mainNav?.classList.toggle('is-open');
  }

  handleSubMenuClick(e: Event): void {
    if (e.target instanceof HTMLElement && e.target.tagName === 'LI') {
      e.preventDefault();
      e.stopPropagation();
      // Close only the siblings' submenus
      const siblings = Array.from(e.target.parentElement!.children) as HTMLLIElement[];
      siblings.forEach(sibling => {
        if (sibling !== e.target) {
          sibling.classList.remove('is-open');
        }
      });

      // Toggle current submenu
      e.target.classList.toggle('is-open');
    }
  }

  closeAllSubMenus(): void {
    this.subMenus.forEach((subMenu) => {
      subMenu.classList.remove('is-open');
    });
  }
}
